import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { pitchesRoute } from './pitches.tsx'

// Censusing a campo, a Panel over the list: a child route, so the list stays mounted under it.
// apps/admin-panel/docs/pattern-di-una-feature.md § «Si crea in un Pannello sopra la lista»
export const newPitchRoute = createRoute({
  getParentRoute: () => pitchesRoute,
  path: 'new',
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/new-pitch.tsx')),
})
